import type { IconProps } from "@chakra-ui/react";
import { AirhelpLogo } from "styles/logos";

const Logo = ({ ...props }: IconProps) => <AirhelpLogo data-testid="top-navbar-logo" {...props} />;

export default Logo;
